import { AllergyIntolerance } from '@medplum/fhirtypes';
import { FC } from 'react';
import { getDisplayString } from '@medplum/core';
import { ResourceListSection } from '../shared/ResourceListSection';
import { ResourceListSectionConfig } from '../shared/ResourceListSectionConfig';
import { createActiveFilter } from '../shared/resource-sort-utils';
import { AllergyListItem } from '../../../examination/allergies/AllergyListItem';

// -----------------------------------------------------------------------------
export interface AllergiesProps {
  readonly allergies: AllergyIntolerance[];
}

// -----------------------------------------------------------------------------
const allergyConfig: ResourceListSectionConfig<AllergyIntolerance> = {
  titleKey: 'summaryPage.summary.allergies.title',
  noneKey: 'summaryPage.summary.allergies.none',
  noResourcesKey: 'summaryPage.summary.allergies.noAllergies',

  sortResources: createActiveFilter<AllergyIntolerance>(
    (allergy) => allergy.clinicalStatus?.coding?.[0]?.code
  ),

  getDisplayDate: (allergy) =>
    allergy.onsetDateTime || allergy.recordedDate || '',

  getDisplayName: (allergy) =>
    allergy.code?.coding?.[0]?.display ||
    allergy.code?.text ||
    getDisplayString(allergy),

  getStatusLabel: (allergy, t) =>
    t(
      `summaryPage.summary.allergies.statusOptions.${allergy.clinicalStatus?.coding?.[0]?.code}`,
      {
        defaultValue: allergy.clinicalStatus?.coding?.[0]?.display,
      }
    ),

  renderItem: (allergy) => (
    <AllergyListItem allergy={allergy} onAction={() => {}} hideActions />
  ),
};

// -----------------------------------------------------------------------------
export const Allergies: FC<AllergiesProps> = ({ allergies }) => {
  return (
    <ResourceListSection<AllergyIntolerance>
      resources={allergies}
      config={allergyConfig}
    />
  );
};
